import { TFunction } from 'i18next';
import { isNullOrUndefined } from 'utils/util';

interface FormatPriceEntity {
  showCode: boolean;
  currency: string;
  formatted: string;
  formattedWithoutCode: string;
}

interface FormatPriceOptions {
  value: number | undefined;
  currency: string | undefined;
  t?: TFunction | undefined;
  l?: string | undefined;
}

export function getFormattedPrice(options: FormatPriceOptions): FormatPriceEntity {
  if (!!options && !!Object.keys(options)?.length) {
    const locale = !!options.t ? options.t('locale') : !!options.l ? options.l : '';
    const showCode = showCurrencyCode({ code: options.currency });
    const { format: f } = formatConstructor({ code: options.currency, locale, showCode });
    const formatted = f(options.value || 0);
    let formattedWithoutCode = '';
    if (!!showCode) {
      const { format: fwc } = formatConstructor({ code: options.currency, locale, showCode: false });
      formattedWithoutCode = fwc(options.value || 0);
    } else {
      formattedWithoutCode = formatted;
    }
    return {
      showCode,
      currency: showCode && !isNullOrUndefined(options.currency) ? (options.currency as string) : '',
      formatted,
      formattedWithoutCode,
    };
  } else return { showCode: false, currency: '', formatted: '', formattedWithoutCode: '' };
}

function showCurrencyCode(options?: { code?: string; showCode?: boolean }): boolean {
  return (
    (!!options?.showCode || options?.showCode === undefined) &&
    !isNullOrUndefined(options?.code) &&
    options?.code !== 'BRL'
  );
}

function formatConstructor(options?: { code?: string; locale: string; showSign?: boolean; showCode?: boolean }) {
  const formatter = new Intl.NumberFormat(options?.locale, {
    minimumFractionDigits: options?.code === 'COP' ? 0 : 2,
    maximumFractionDigits: options?.code === 'COP' ? 0 : 2,
  });

  const getSign = (code) => {
    switch (code) {
      case 'BRL':
        return 'R$';
      default:
        return '$';
    }
  };

  const showCode = showCurrencyCode({ code: options?.code, showCode: options?.showCode });

  return {
    format: (value: number) =>
      `${options?.showSign || options?.showSign === undefined ? getSign(options?.code || '') : ''}${formatter.format(
        value,
      )}${showCode ? ` ${options?.code}` : ''}`,
  };
}
